(function () {
  var STORAGE_KEY = 'bshop_cookie_consent';

  function getStoredConsent() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setStoredConsent(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // localStorage not available; consent choice won't persist across visits
    }
  }

  function updateGtagConsent(granted) {
    if (typeof window.gtag !== 'function') return;
    var state = granted ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
      analytics_storage: state
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var stored = getStoredConsent();

    if (stored === 'granted') {
      updateGtagConsent(true);
      return;
    }
    if (stored === 'denied') {
      return;
    }

    var banner = document.getElementById('bshop-cookie-banner');
    if (!banner) return;

    banner.hidden = false;

    var acceptBtn = document.getElementById('bshop-cookie-accept');
    var rejectBtn = document.getElementById('bshop-cookie-reject');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        setStoredConsent('granted');
        updateGtagConsent(true);
        banner.hidden = true;
      });
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        setStoredConsent('denied');
        banner.hidden = true;
      });
    }
  });
})();
